import styled from "styled-components";
export const MenueButton = styled.div`
  /* border:1px solid rgba(0, 0, 0, 0.1); */
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  /* padding: 0; */
  justify-content: center;
  align-items: center;
  display: ${({ theme }) =>
    !["xm"].includes(theme.windowWidth) ? "none" : "flex"};
  /* position: absolute; */
  /* left: 0; */
  height: 40px !important;
  width: 40px !important;
  border-radius: 100% !important;
  /* margin-left: 10px; */
  /* z-index: 99; */
  cursor: pointer;
  position: absolute;
  z-index: 99;
  left: 14%;
  top: 2%;


  background: #fff;

  ${({ right }) =>
    right ? "left: unset; right: 10px; position: absolute" : ""};
`;
